/**
 * Part of wushifarm project.
 *
 * @copyright  Copyright (C) 2023 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import '@main';

class HeaderCartItemList {
  constructor(el) {
    this.el = el;

    this.loadData();

    u.on('cart.update', () => {
      this.loadData();
    });
  }

  async loadData() {
    try {
      const res = await u.$http.get(
        '@cart_ajax/loadHeaderCartData'
      );

      this.el.innerHTML = res.data.data;
    } catch (e) {
      console.error(e);
      u.alert(e.message, '', 'warning');
    }
  }
}

u.directive(
  'header-cart-item-list',
  {
    mounted(el) {
      u.module(el, 'header.cart.item.list', (el) => new HeaderCartItemList(el));
    }
  }
);
